import { render, staticRenderFns } from "./OrderStepCart.vue?vue&type=template&id=5247d4e5&"
import script from "./OrderStepCart.vue?vue&type=script&lang=js&"
export * from "./OrderStepCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports